import { tt } from './i18n'

/**
 * What an order's status is called, in Slovak — §9.149.
 *
 * <p>Shared because two modules that do not depend on each other both draw it: `manager-orders` on
 * the archive, the till and the preorder list, and `manager-delivery` on the dispatch board. The
 * board rendered `order.status` raw for want of this — `new`, `preparing`, `quality_check` on a
 * screen the owner reads across a kitchen.
 *
 * <p>The **colours** deliberately do not live here. `manager-orders` keeps its badge palette, which
 * needs `@agos/ui`'s `BadgeColor`, and the dispatch board keeps legacy's own strip palette: the same
 * status is violet in one and near-black in the other, on purpose, because they are different
 * pictures. A shared colour map would have to pick one and break the other.
 */
export const ORDER_STATUS_LABELS: Record<string, string> = {
  pending: tt('Čaká na prijatie'),
  new: tt('Nová'),
  confirmed: tt('Potvrdená'),
  preparing: tt('Príprava'),
  quality_check: tt('Kontrola kvality'),
  ready: tt('Pripravená'),
  on_the_way: tt('Na ceste'),
  at_address: tt('Na adrese'),
  delivered: tt('Doručená'),
  cancelled: tt('Zrušená'),
}

/** The label, or the key itself when a franchise's backend sends one this map has not heard of. */
export function orderStatusLabel(status: string | undefined): string {
  if (!status) return ''
  return ORDER_STATUS_LABELS[status] ?? status
}
